import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  FormFeedback,
  Input,
  Form,
  Label,
} from "reactstrap"
import Select from "react-select"
import * as Yup from "yup"
import { useFormik } from "formik"
import Switch from "react-switch"
import MetaTags from "react-meta-tags"
import moment from "moment"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { mobileRegex, iuRegex,vehicleRegex } from "../../helpers/validator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  statusTypes,
  messageTitle,
  guestAccessType,
  vehicleTypes,
  guestStatusTypes,
} from "constants/common"
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"

import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import {
  getGuests as onGetGuests,
  updateGuest as onUpdateGuest,
  clearMessage,
  updateGuestAccess as onUpdateGuestAccess,
  guestComplimentaryAccessRequest as onComplimentaryRequest,
} from "store/guest/actions"
import { getUsers as onGetUsers } from "store/user/actions"
import { getRoles as onGetRoles } from "../../store/roles/actions"
import { getCarParks as onGetCarParks } from "../../store/carpark/actions"
import { isEmpty, isUndefined, map, orderBy } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"

const getUser = user => {
  if (user) {
    return {
      value: user?._id || "",
      label: user?.name || "",
    }
  }
  return null
}

const sizePerPage = 25
const GuestApproval = props => {
  const dispatch = useDispatch()
  const [guest, setGuest] = useState()
  const [vehicleType, setVehicleType] = useState(vehicleTypes.car)
  const [carParkList, setCarparkList] = useState([])

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      guestName: (guest && guest.guestName) || "",
      guestVehicleNumber: (guest && guest.guestVehicleNumber) || "",
      guestInVehicleUnit: (guest && guest.guestInVehicleUnit) || "",
      visitDate: convertUtcToLocal(guest?.visitDate || new Date()),
      purpose: guest?.purpose || "",
    },
    validationSchema: Yup.object({
      guestName: Yup.string()
        .required("Please Enter Your Name")
        .min(5, "Must be at least 5 characters"),
      guestVehicleNumber: Yup.string()
        .required("A valid Vehicle Number is required")
        .matches(vehicleRegex,"Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      guestInVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
    }),
    onSubmit: values => {
      if (isEmpty(selectedSponsor)) {
        setCustValidation({ validSponsor: false, validCarpark: true })
        return
      }
      if (isEmpty(selectedCarpark)) {
        setCustValidation({ validSponsor: true, validCarpark: false })
        return
      }

      if (isEdit) {

        const updateGuest = {
          id: guest.id,
          guestName: values.guestName,
          sponsor: selectedSponsor?.value || "",
          guestVehicleNumber: values.guestVehicleNumber,
          guestInVehicleUnit: values.guestInVehicleUnit,
          visitDate: convertDateToUtc(values["visitDate"]),
          status: guest?.status,
          carPark: selectedCarpark.value,
          purpose: values["purpose"],
          vehicleType
        }
        // update guest
        dispatch(onUpdateGuest(updateGuest))
        validation.resetForm()
        setIsEdit(false)
      } else {
        const newGuest = {
          guestName: values["guestName"],
          sponsor: selectedSponsor?.value || "",
          guestVehicleNumber: values["guestVehicleNumber"],
          guestInVehicleUnit: values["guestInVehicleUnit"],
          vehicleType,
          visitDate: convertDateToUtc(values["visitDate"]),
          status: guestAccessType.Approved,
          carPark: selectedCarpark.value,
          purpose: values["purpose"],
        }
        // save new guest
        dispatch(onAddNewGuest(newGuest))
      }
      toggle()
    },
  })

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const {
    guests,
    userList,
    message,
    pagination,
    error,
    // carParkList,
  } = useSelector(state => ({
    guests: state.guests.guestList,
    pagination: state.guests.pagination,
    message: state.guests.message,
    error: state.guests.error,
    userList: state.users.userList,
    // carParkList: state.carPark.carParkList,
  }))

  const [currentPage, setCurrentPage] = useState(1)
  const [complimentaryAccess, setComplimentaryAccess] = useState(false)
  const [modal, setModal] = useState(false)
  // const [updateModal, setUpdateModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedSponsor, setSelectedSponsor] = useState(
    getUser(guest?.sponsor || null)
  )
  const [selectedCarpark, setSelectedCarpark] = useState(null)
  const [users, setUsers] = useState([])
  const [customValidation, setCustValidation] = useState({
    validSponsor: true,
    validCarpark: true,
  })

  const [carparks, setCarparks] = useState([])
  const [reasonText, setReasonText] = useState("")
  const { SearchBar } = Search
  const [searchKey, setSearchKey] = useState("");

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0,
    custom: true,
    totalPages: pagination?.totalPages || 0,
  }

  useEffect(()=>{
    if (searchKey.length >= 2 || searchKey == "") {
      dispatch(onGetGuests({
      status: guestStatusTypes.Pending,
      search: searchKey }));
    }
  },[searchKey]);

  const defaultSorted = [
    {
      dataField: "visitDate",
      order: "desc", // desc or asc
    },
  ]

  useEffect(() => {
    dispatch(onGetRoles())
    dispatch(onGetCarParks({ status: "Available" }))
    if (isEmpty(userList)) {
      dispatch(
        onGetUsers({
          status: [statusTypes.Approved, statusTypes.Available]
        })
      )
    }
    setTimeout(() => {
      dispatch(
        onGetGuests({
          status: statusTypes.Pending,
          search: searchKey,
        })
      )
    }, 500)
  }, [])

  useEffect(() => {
    if (!isEmpty(guests) && !!isEdit) {
      setIsEdit(false)
    }
  }, [guests])

  const guestListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user._id}</>,
    },
    {
      text: "Guest Name",
      dataField: "guestName",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, guest) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {guest.guestName}
            </Link>
          </h5>
          <p className="text-muted mb-0">{guest.guestId}</p>
        </>
      ),
    },
    {
      text: "Guest Vehicle Details",
      dataField: "guestVehicleNumber",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, guest) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {guest.guestVehicleNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{guest.guestInVehicleUnit}</p>
        </>
      ),
    },
    {
      dataField: "sponsorName",
      text: "Sponsor Details",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            <p className="text-muted mb-0">{record?.sponsor?.userId || ""}</p>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {record?.sponsor?.name}
              </Link>
            </h5>
            {/* <p className="text-muted mb-0">{role?.roleTitle || ""}</p> */}
            <p className="text-muted mb-0">
              {/* if role doesn't exist then role title will be not display */}
              {record?.sponsor?.role?.roleTitle || ""}
            </p>
          </>
        )
      },
    },
    {
      dataField: "visitDate",
      text: "Visit Date/Carpark",
      sort: true,
      formatter: (cellContent, record) => {        
        return (
          <>
            <p>
              {convertUtcToLocal(record?.visitDate, "Do MMM YYYY")}
              {"|"}
              {/* {(!isUndefined(carpark) && carpark?.carParkTitle) || ""} */}
              <strong>{record?.carPark?.carParkTitle}</strong>
            </p>
            <p>{record?.purpose || ""}</p>
          </>
        )
      },
    },
    {
      text: "Applied On",
      dataField: "createdAt",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal" }}>
            {convertUtcToLocal(record?.createdAt) }
          </div>
        )
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => {
        return (
          <div className="d-flex gap-3">
            <Link
              className="text-primary"
              to="#"
              style={{
                opacity: record?.status == "Removed" ? "0.4" : 5,
                pointerEvents: record?.status == "Removed" ? "none" : "auto",
              }}
            >
              <i
                className="mdi mdi-account-edit font-size-24"
                id="edittooltip"
                // style={{ opacity: "0.4", cursor: "default" }}
                onClick={() => handleEditClick(record)}
                data-toggle="tooltip"
                data-placement="top"
                title="Update Guest Approval"
              ></i>
            </Link>
            <Link className="text-success" to="#"
              style={{
                opacity: moment().diff(moment(record?.visitDate), "days") > 0 ? "0.4" : 5,
                pointerEvents: moment().diff(moment(record?.visitDate), "days") > 0 ? "none" : "auto",
              }}>
              <i
                className="mdi mdi-account-heart font-size-24"
                id="tooltip"
                onClick={() =>
                  handleGuestClick(record, guestAccessType.Complimentary)
                }
                data-toggle="tooltip"
                data-placement="top"
                title="Grant Complimentary Access"
              ></i>
            </Link>
            <Link className="text-warning" to="#"
              style={{
                opacity: moment().diff(moment(record?.visitDate), "days") > 0 ? "0.4" : 5,
                pointerEvents: moment().diff(moment(record?.visitDate), "days") > 0 ? "none" : "auto",
              }}>

              <i
                className="mdi mdi-account-cash font-size-24"
                id="tooltip"
                onClick={() => handleGuestClick(record, guestAccessType.Approved)}
                data-toggle="tooltip"
                data-placement="top"
                title="Grant Paid Access"
              ></i>
            </Link>
            <Link className="text-dark" to="#">
              <i
                className="mdi mdi-account-lock font-size-24"
                id="deletetooltip"
                onClick={() => handleGuestClick(record, guestAccessType.Removed)}
                data-toggle="tooltip"
                data-placement="top"
                title="Deny Access"
              ></i>
            </Link>
          </div>
        )
      },
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const handleEditClick = arg => {
    const guest = arg

    setGuest({
      id: guest._id,
      ...guest,
    })

    setSelectedSponsor(getUser(guest?.sponsor || null))
    const user = userList.find(el => el._id == guest?.sponsor?._id)
    if (user) {
      setCarparkList(user?.season?.carparks)
    }

    setSelectedCarpark({
      value: guest?.carPark?._id,
      label: guest?.carPark?.carParkTitle,
    })

    setComplimentaryAccess(
      guest?.status == guestAccessType.Complimentary
    )

    setIsEdit(true)
    if (guest.vehicleType == vehicleTypes.bike) {
      setVehicleType(vehicleTypes.bike)
    } else {
      setVehicleType(vehicleTypes.car)
    }
    toggle()
  }

  const handleSponser = e => {
    if (e) {
      setSelectedSponsor(e)
      const user = userList.find(el => el._id == e.value)
      if (user) {
        setCarparkList(user?.season?.carparks)
      }
    }
  }

  useMemo(() => {
    dispatch(
      onGetUsers({
        status: [statusTypes.Approved, statusTypes.Available]
      })
    )
  }, [])

  useMemo(() => {
    if (!isEmpty(userList)) {
      setUsers(userList)
    }
  }, [userList])

  useMemo(() => {
    if (!isEmpty(carParkList)) {
      setCarparks(carParkList)
    }
  }, [carParkList])

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      dispatch(
        onGetGuests({
          status: guestAccessType.Pending,
          search: searchKey,
        })
      )
      setModal(false)
      setGuest(null)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  const handleGuestClick = (guest, status) => {
    setDeleteModal(true)
    // setModal(true)
    setGuest({ ...guest, status: status })
  }
  const handleUpdateClick = () => {

    let updateGuest = {
      id: guest._id,
      status: guest.status,
      reason: reasonText,
    }
    if (guest?.status == guestAccessType.Complimentary) {
      dispatch(onComplimentaryRequest({bodyData:updateGuest}))
    } else {
      dispatch(onUpdateGuestAccess(updateGuest))
    }  
    setDeleteModal(false)     
    
  }

  const keyField = "key_id"

  const sponsorOptions = (users || []).map(el => ({
    value: el._id,
    label: el.name,
  }))

  const carParkOptions = (carParkList || []).map(el => ({
    value: el._id,
    label: el.carParkTitle,
  }))

  const sponsorDetails = (users || []).find(
    el => el._id == (selectedSponsor?.value || "")
  )

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleUpdateClick}
        onCloseClick={() => setDeleteModal(false)}
        title={
          guest?.status == guestAccessType.Approved
            ? `Approve guest ${guest?.guestName} access?`
            : guest?.status == guestAccessType.Complimentary
              ? `Request guest ${guest?.guestName} with complimentary access?`
              : `Deny guest ${guest?.guestName} access?`
        }
        text={
          guest?.status == guestAccessType.Approved
            ? "Yes, Approve it!"
            : guest?.status == guestAccessType.Complimentary
              ? "Yes, Request!"
              : "Yes, Deny it!"
        }
        icon={
          guest?.status == guestAccessType.Approved
            ? "mdi mdi-account-cash"
            : guest?.status == guestAccessType.Complimentary
              ? "mdi mdi-account-heart"
              : "mdi mdi-account-lock"
        }
        iconColor={
          guest?.status == guestAccessType.Approved
            ? "text-warning"
            : guest?.status == guestAccessType.Complimentary
              ? "text-success"
              : "text-dark"
        }
        childComponent={
          guest?.status == guestAccessType.Removed ? (
            <textarea
              name="reasonText"
              className="form-control"
              id="reasonText"
              rows="2"
              onChange={e => setReasonText(e.target.value)}
              onBlur={e => setReasonText(e.target.value)}
              value={reasonText || ""}
            />
          ) : null
        }
      />
      <div className="page-content">
        <MetaTags>
          <title>Manage Guest Approval | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Users" breadcrumbItem="Manage Guest Approval" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField={keyField}
                    columns={guestListColumns}
                    data={guests || []}
                  >
                    {({ paginationProps, paginationTableProps }) => {
                      return (
                        
                      )
                    }}
                  </PaginationProvider> */}
                  <ToolkitProvider
                    keyField={keyField}
                    data={guests || []}
                    columns={guestListColumns}
                    bootstrap4
                    search
                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row className="mb-2">
                          <Col sm="4">
                            <div className="search-box ms-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                {/* <SearchBar
                                  {...toolkitProps.searchProps}
                                /> */}
                                <input
                                  id="search-bar-0"
                                  type="text"
                                  className="form-control "
                                  placeholder="Search"
                                  value={searchKey}
                                  onChange={e => setSearchKey(e.target.value)}
                                />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="8"></Col>
                        </Row>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={keyField}
                                {...toolkitProps.baseProps}
                                // {...paginationTableProps}
                                defaultSorted={defaultSorted}
                                classes={
                                  "table align-middle table-nowrap table-hover"
                                }
                                bordered={false}
                                striped={false}
                                responsive
                                noDataIndication={emptyDataMessage}
                              />

                              <Modal
                                className={"modal-lg"}
                                isOpen={modal}
                                toggle={toggle}
                              >
                                <ModalHeader toggle={toggle} tag="h4">
                                  {/* {!!isEdit
                                          ? "Update Guest"
                                          : "Add New Guest"} */}
                                  Update Guest
                                </ModalHeader>
                                <ModalBody>
                                  <Form
                                    onSubmit={e => {
                                      e.preventDefault()
                                      validation.handleSubmit()
                                      return false
                                    }}
                                  >
                                    <Row form>
                                      <Col xs={12}>
                                        <Row>
                                          <Col md={6}>
                                            <div className="mb-2">
                                              <label className="form-label">
                                                Sponsor Name
                                              </label>
                                              <Select
                                                name="role"
                                                value={selectedSponsor}
                                                onChange={e => {
                                                  setCustValidation({
                                                    ...customValidation,
                                                    validSponsor: true,
                                                  })
                                                  handleSponser(e)
                                                }}
                                                options={sponsorOptions}
                                                classNamePrefix="select2-selection"
                                              />
                                              {!customValidation.validSponsor && (
                                                <div
                                                  className="invalid-feedback"
                                                  style={{
                                                    display: "block",
                                                  }}
                                                >
                                                  Please select sponsor
                                                </div>
                                              )}
                                            </div>
                                          </Col>
                                          <Col md={6}>
                                            <div className="mb-2">
                                              <label className="form-label">
                                                Sponsor Details
                                              </label>
                                              <p className="mt-2 mb-1">
                                                {sponsorDetails
                                                  ? `${sponsorDetails?.role
                                                    ?.roleTitle || ""
                                                  } | ${sponsorDetails?.department ||
                                                  ""
                                                  }`
                                                  : " - "}
                                              </p>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg={12}>
                                            <div className="mb-3">
                                              <Label className="form-label col-lg-2">
                                                Guest Name*
                                              </Label>
                                              <Input
                                                name="guestName"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .guestName || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .guestName &&
                                                    validation.errors
                                                      .guestName
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .guestName &&
                                                validation.errors
                                                  .guestName ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .guestName
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md={3}>
                                            <Row>
                                              <Col>
                                                <div className="form-check mt-4 mb-1">
                                                  <input
                                                    type="radio"
                                                    id="customRadio1"
                                                    name="customRadio"
                                                    className="form-check-input"
                                                    defaultChecked={
                                                      vehicleType ==
                                                      vehicleTypes.car
                                                    }
                                                    onChange={e =>
                                                      setVehicleType(
                                                        vehicleTypes.car
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    htmlFor="customRadio1"
                                                  >
                                                    Car
                                                  </label>
                                                </div>
                                              </Col>
                                              <Col>
                                                <div className="form-check mt-4">
                                                  <input
                                                    type="radio"
                                                    id="customRadio2"
                                                    name="customRadio"
                                                    className="form-check-input"
                                                    defaultChecked={
                                                      vehicleType ==
                                                      vehicleTypes.bike
                                                    }
                                                    onChange={e =>
                                                      setVehicleType(
                                                        vehicleTypes.bike
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    htmlFor="customRadio2"
                                                  >
                                                    Bike
                                                  </label>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col md={4}>
                                            <div className="mb-2">
                                              <Label className="form-label">
                                                Vehicle Number*
                                              </Label>
                                              <Input
                                                name="guestVehicleNumber"
                                                label="guestVehicleNumber"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .guestVehicleNumber ||
                                                  ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .guestVehicleNumber &&
                                                    validation.errors
                                                      .guestVehicleNumber
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .guestVehicleNumber &&
                                                validation.errors
                                                  .guestVehicleNumber ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .guestVehicleNumber
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                                          </Col>
                                          <Col md={5}>
                                            <div className="mb-2">
                                              <Label className="form-label">
                                                In-vehicle Unit*
                                              </Label>
                                              <Input
                                                name="guestInVehicleUnit"
                                                label="guestInVehicleUnit"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .guestInVehicleUnit ||
                                                  ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .guestInVehicleUnit &&
                                                    validation.errors
                                                      .guestInVehicleUnit
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .guestInVehicleUnit &&
                                                validation.errors
                                                  .guestInVehicleUnit ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .guestInVehicleUnit
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                                          </Col>
                                        </Row>
                                        <div className="mb-3">
                                          <h5 className="font-size-14 mb-3 mt-4">
                                            Grant Guest Access
                                          </h5>
                                        </div>
                                        <Row>
                                          <Col md={5}>
                                            <div className="mb-2">
                                              <label className="form-label">
                                                Carpark
                                              </label>
                                              <Select
                                                //closeMenuOnSelect={false}
                                                name={"carParkApplicable"}
                                                value={selectedCarpark}
                                                onChange={e => {
                                                  setCustValidation({
                                                    ...customValidation,
                                                    validCarpark: true,
                                                  })
                                                  setSelectedCarpark(e)
                                                }}
                                                options={carParkOptions}
                                                classNamePrefix="select2-selection"
                                              />
                                              {!customValidation.validCarpark && (
                                                <div
                                                  className="invalid-feedback"
                                                  style={{
                                                    display: "block",
                                                  }}
                                                >
                                                  Please select at least
                                                  one applicable carpark
                                                </div>
                                              )}
                                            </div>
                                          </Col>
                                          <Col md={4}>
                                            <div className="mb-2">
                                              <Label className="form-label">
                                                Requested Visit Date
                                              </Label>
                                              <Input
                                                type="date"
                                                defaultValue={
                                                  validation.values
                                                    .visitDate
                                                }
                                                id="visitDate"
                                                name="visitDate"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                invalid={
                                                  validation.touched
                                                    .visitDate &&
                                                    validation.errors
                                                      .visitDate
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .visitDate &&
                                                validation.errors
                                                  .visitDate ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .visitDate
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </div>
                                          </Col>
                                          {/* <Col md={3}>
                                            <div className="mb-2">
                                              <Label className="form-label">
                                                Complimentary Access
                                              </Label>
                                              <Col
                                                md={2}
                                                className="pt-1"
                                              >
                                                <Switch
                                                  checked={
                                                    complimentaryAccess
                                                  }
                                                  onColor="#626ed4"
                                                  onChange={() =>
                                                    setComplimentaryAccess(
                                                      !complimentaryAccess
                                                    )
                                                  }
                                                  uncheckedIcon={
                                                    <OnSymbol text="No" />
                                                  }
                                                  checkedIcon={
                                                    <OffSymbol text="Yes" />
                                                  }
                                                  disabled
                                                />
                                              </Col>
                                            </div>
                                          </Col> */}
                                        </Row>
                                        <Row>
                                          <Col md={12}>
                                            <div className="mb-2">
                                              <Label className="form-label">
                                                Purpose
                                              </Label>
                                              <Input
                                                name="purpose"
                                                type="textarea"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .purpose || ""
                                                }
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                    <Row className="mt-4">
                                      <Col>
                                        <div className="text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-success save-user"
                                          >
                                            {!!isEdit
                                              ? "Update Guest"
                                              : "Add New Guest"}
                                          </button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Form>
                                </ModalBody>
                              </Modal>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row> */}
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(GuestApproval)
